import { Badge, Button } from 'avo-ui'
import icThreeDots from 'assets/images/ic-three-dots.svg'

export const TABLE_PARTNERSHIP = {
    name: 'Partnership',
    column: [
        {
            name: 'Nama',
            key: 'name',
            className: 'capitalize',
        },
        {
            name: 'Email',
            key: 'email',
        },
        {
            name: 'Phone Number',
            key: 'phone_number',
        },
        {
            name: 'Nama Company',
            key: 'company_name',
            className: 'capitalize',
        },
        {
            name: 'Deskripsi',
            key: 'description',
            className: 'whitespace-pre-line'
        },
        {
            name: 'Attachments',
            key: 'attachments',
            classNameHeader: '!text-center',
            width: 100,
            render: ({ item, onClickItem }) => (
                <div className={'flex justify-center'}>
                    <Button
                        icon={icThreeDots}
                        className={'!rounded-full'}
                        onClick={() =>
                            onClickItem({
                                attachment_1: {
                                    label: 'Brand Website',
                                    link: item?.web_url,
                                },
                                attachment_2: {
                                    label: 'Social Media',
                                    link: item?.social_media_url,
                                },
                                attachment_3: {
                                    label: 'Company Profile / Catalog Deck',
                                    link: item?.catalog_deck_url,
                                },
                            })
                        }
                    />
                </div>
            ),
        },
        {
            name: 'Status',
            key: 'status',
            render: ({ value }) => <Badge title={value?.replace('-', ' ')} type={value} />,
        },
    ],
}

export const INITIAL_DATA_FILTER = {
    search: '',
    page: 1,
    limit: 20,
}
